<template lang="pug">
  div
    //- v-app-bar.pt-2.headerOnScroll(app height="85",fixed dark shrink-on-scroll scroll-threshold="200", :class="!toStrink && isWelcome ?'noBackColor':''")
    v-app-bar.pt-2.headerOnScroll(app height="85",fixed dark shrink-on-scroll scroll-threshold="200", :class="!toStrink ?'noBackColor':''")
      v-img.shrink.mr-2(alt='COR_UCC Logo',contain src='../assets/COR_Logo.png' transition='scale-transition', :width="toStrink ? '30' : '45'")
      v-img.shrink.mt-2(alt='COR_UCC Name',contain min-width='100' src='../assets/LogoTitle_white.png', transition='scale-transition', :width="toStrink ? '125' : '160'")
      v-spacer
      v-toolbar-items.hidden-sm-and-down
        Welcome(:fromDrawer="false" :fromMenu="true")
        About(:fromDrawer="false" :fromMenu="true")
        Ministries(:fromDrawer="false" :fromMenu="true")
        //- Events(:fromDrawer="false" :fromMenu="true")
        Media(:fromDrawer="false" :fromMenu="true")
        Visit(:fromDrawer="false" :fromMenu="true")
        Offerings(:fromDrawer="false" :fromMenu="true")
      v-icon.mdi.mdi-menu.hidden-md-and-up(large @click.stop="drawer = !drawer")
      //- v-icon.mdi.mdi-close.hidden-sm-and-up(large)
      v-icon.mdi.mdi-magnify.hidden-sm-and-down(large)
      v-btn#joinUs(fab fixed large color='info',bottom right @click='dialog = !dialog' :class="toStrink ? 'btnShrinkTop' : 'btnTop'")
        | Join Us
        //- v-icon mdi-plus
    Dialog(:dialog.sync="dialog" @update:dialog="doDialog")
    Drawer(:adrawer.sync="drawer")
    div(v-scroll="onScroll")
</template>
<script>
/* eslint-disable vue/valid-v-on */
import Drawer from '../components/header/navDrawer';
import Dialog from '../components/header/dialog';
import Welcome from '../components/MenuItems/Welcome';
import About from '../components/MenuItems/About';
import Visit from '../components/MenuItems/Visit';
import Media from '../components/MenuItems/Media';
import Offerings from '../components/MenuItems/Offerings';
import Events from '../components/MenuItems/Events';
import Ministries from '../components/MenuItems/Ministries';
export default {
  mounted() {
    let root = window.location.pathname.split('/')[1];
    if (root == '' || root == 'welcome') {
      this.$store.commit('setRoot', 'welcome');
    } else {
      this.$store.commit('setRoot', root);
    }
  },
  components: {
    Drawer,
    Dialog,
    Welcome,
    About,
    Visit,
    Media,
    Offerings,
    Events,
    Ministries
  },
  data() {
    return {
      // activeBtn: true,
      dialog: null,
      drawer: null,
      toStrink: false
    };
  },
  computed: {
    isWelcome() {
      let theRoot = this.$store.getters.getRoot;
      console.log('TCL: isActive -> theRoot', theRoot);
      return theRoot == 'welcome' ? true : false;
    }
  },
  methods: {
    doDialog() {
      console.log('parent dialog', this.dialog);
    },
    onScroll(e) {
      let offsetTop = e.target.documentElement.scrollTop;
      let theRoot = this.$store.getters.getRoot;
      if (offsetTop >= 200) {
        this.toStrink = true;
        console.log('TCL: onScroll -> offsetTop', offsetTop);
      } else {
        this.toStrink = false;
      }
      console.log('at here -->', offsetTop);
    }
  }
  // theRoot == 'welcome'
};
</script>
<style lang="stylus">
#header, .headerOnScroll
  background-color rgba(45, 50, 132, 0.9) !important

.imageTop
  margin-top -85px
  border-radius 0

.noBackColor
  background-color rgba(0, 0, 0, 0.1) !important

.menuBtn
  font-family Montserrat, Arial, Sans-Serif

.v-btn
  font-weight 600 !important

.theList
  // margin-top: 2px;
  // font-family: Montserrat, Arial, Sans-Serif;

button#joinUs
  color #2D3284
  padding 10px
  width 100px

.btnTop
  top 75px

.btnShrinkTop
  top 50px

@media screen and (max-width: 950px)
  button#joinUs
    width 65px
    height 42px
    font-size 8px
</style>
